import { render, staticRenderFns } from "./FaceRadio.vue?vue&type=template&id=92ddef5e&scoped=true&lang=pug&"
import script from "./FaceRadio.vue?vue&type=script&lang=ts&"
export * from "./FaceRadio.vue?vue&type=script&lang=ts&"
import style0 from "./FaceRadio.vue?vue&type=style&index=0&id=92ddef5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ddef5e",
  null
  
)

export default component.exports